import React, { Fragment, useEffect, useState, useContext } from "react";
import PropTypes from "prop-types";
import Images from 'assets/images/imageData';
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import FormSection from "components/sales/formSection/formSection";
import localization from "assets/localization/localization";
import DropDownInput from "components/sales/Input/dropDownInput/dropDownInput";
import ConstantInput from "components/sales/Input/constantInput/constantInput";
import { DatePickerInput } from "rc-datepicker";
import { Button, FormGroup } from "react-bootstrap";
import { BaseUrl } from 'contexts/baseUrl/baseUrl';
import FileUpload from "components/sales/fileUpload/fileUpload";
import * as moment from "moment";
import ModalPop from "components/sales/modal/modal";
// import s from "./addPayment.module.css";
import axios from "services/interceptor/Interceptor";
import Config from "services/config/config";
import { ToastContainer, toast } from "react-toastify";
import TimePicker from 'react-times';
import 'react-toastify/dist/ReactToastify.css';

const AddHelpdeskPopup = ({
  changeStatus,
  onClosePopup = () => { },
  currentCarnivalStatus,
  carnivalId,
  projectId,
  startDate,
  endDate,
  history,
  pageNumber,
  getHelpdeskList
}) => {
  const [newStatus, setNewStatus] = useState();
  const [isModal, setIsModal] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [newStartDate, setStartDate] = useState(null);
  const [newStartTime, setStartTime] = useState(null);
  const [newEndTime, setEndTime] = useState(null);
  const [newEndDate, setEndDate] = useState(null);
  const [minDateIndex, setMinDateIndex] = useState(null);
  const { baseUrl } = useContext(BaseUrl);

  const handleStartDate = (date, dateString) => {
    setStartDate(dateString);
    setMinDateIndex(dateString);
  };

  const handleEndDate = (date, dateString) => {
    setEndDate(dateString);
  };

  function onStartChange(value) {
    const { hour, minute } = value;
    setStartTime(`${hour}:${minute}`);
  }

  function onEndChange(value) {
    const { hour, minute } = value;
    setEndTime(`${hour}:${minute}`);
  }

  async function submit() {
    try {
      setIsLoading(true);
      let url;
      url = Config.brandActivation.updateHelpdeskStatus;
      if (currentCarnivalStatus === 'Hold' && newStatus === 'Active') {
        if (newStartDate == null || newStartTime == null || newEndDate == null || newEndTime == null) {
          toast.error('Please fill all details.');
          return false;
        }
      }
      const payload = {
        carnival_id: carnivalId,
        project_id: projectId,
        new_carnival_status: newStatus,
        current_status: currentCarnivalStatus,
        new_start_date: newStartDate,
        new_start_time: newStartTime,
        new_end_date: newEndDate,
        new_end_tme: newEndTime
      };

      const { data } = await axios.post(url, payload);
      onClosePopup();
      if (data.response.message) {
        if (data.response.status === false) {
          toast.error(data.response.message);
        } else {
          toast.success(data.response.message);
          await getHelpdeskList('', pageNumber);
        }

      } else {
        toast.error('Something went wrong, Please try again');
      }
      setIsLoading(false);
    } catch (error) {
      toast.error(error?.response?.data?.message || 'Something went wrong, Please try again')
      setIsLoading(false);
    }
  }

  const handleModalHide2 = () => {
    history.push(`${baseUrl}/brand-activation/conduct-carnival/carnival`);
  };

  const carnivalStatus = () => {
    return (
      <div>
        <div>
          <div>
            <h5>Project Id: {projectId}</h5>
            <h5>Start Date: {startDate}</h5>
            <h5>End Date: {endDate}</h5>
          </div>
          <div /* className={s.parallel_fields} */>
            <DropDownInput
              label={localization.status}
              data={
                (currentCarnivalStatus == 'Active') ?
                  [
                    { id: "Inactive", name: "Inactive" },
                    { id: "Hold", name: "Hold" },
                    { id: "Completed", name: "Completed" }
                  ]
                  : (currentCarnivalStatus == 'Hold') ?
                    [
                      { id: "Active", name: "Active" },
                      { id: "Inactive", name: "Inactive" },
                    ]
                    : (currentCarnivalStatus == 'Inactive') ?
                      [
                        { id: "Active", name: "Active" }
                      ]
                      : null
              }
              required
              errorMsg={localization.requiredStatus}
              getIdValue={(val) => {
                setNewStatus(val.id);
              }}
              isStarRequired={true}
            />

            {newStatus == 'Active' &&
              <>
                <div className="row form-group">
                  <div className="col-md-6 col-sm-12">
                    <FormGroup
                      className={`date custom_date_picker active-date`}
                    >
                      <DatePickerInput
                        value={newStartDate}
                        onChange={handleStartDate}
                        autoClose
                        closeOnClickOutside
                        showOnInputClick
                        locale="en"
                        className="my-custom-datepicker-component"
                        required
                        displayFormat="DD-MM-YYYY"
                        returnFormat="YYYY-MM-DD"
                        minDate={new Date()}
                      // value={formData?.start_date}
                      />
                      <label>
                        {localization.startDate}{' '}
                        <span className="label-star" style={{ color: 'red' }}>
                          {' '}
                          *{' '}
                        </span>
                      </label>

                    </FormGroup>
                  </div>
                  <div className="col-md-6 col-sm-12">
                    <FormGroup>
                      <TimePicker
                        theme="classic"
                        timeFormat="HH:MM"
                        timeMode={24}
                        time={newStartTime}
                        onTimeChange={onStartChange}
                      />
                      <label>{localization.startTime}{' '}
                        <span className="label-star" style={{ color: 'red' }}>
                          {' '}
                          *{' '}
                        </span></label>
                      <label className="error date_error">{localization.isRequired}</label>
                    </FormGroup>
                  </div>
                  <div className="col-md-6 col-sm-12">
                    <FormGroup
                      className={`date custom_date_picker active-date`}
                    >
                      <DatePickerInput
                        value={newEndDate}
                        onChange={handleEndDate}
                        autoClose
                        closeOnClickOutside
                        showOnInputClick
                        locale="en"
                        className="my-custom-datepicker-component"
                        required
                        displayFormat="DD-MM-YYYY"
                        returnFormat="YYYY-MM-DD"
                        minDate={minDateIndex === null
                          ? new Date()
                          : minDateIndex}
                      />
                      <label>
                        {localization.endDate}{' '}
                        <span className="label-star" style={{ color: 'red' }}>
                          {' '}
                          *{' '}
                        </span>
                      </label>

                    </FormGroup>
                  </div>
                  <div className="col-md-6 col-sm-12">
                    <FormGroup>
                      <TimePicker
                        theme="classic"
                        timeFormat="HH:MM"
                        timeMode={24}
                        time={newEndTime}
                        onTimeChange={onEndChange}
                      />
                      <label>{localization.endTime}{' '}
                        <span className="label-star" style={{ color: 'red' }}>
                          {' '}
                          *{' '}
                        </span></label>
                      <label className="error date_error">{localization.isRequired}</label>
                    </FormGroup>
                  </div>
                </div>
              </>
            }

          </div>
          <hr style={{ marginTop: "24px" }} />
          <div>
            <div>
              <Button onClick={() => submit()}
                disabled={
                  false
                }>Submit</Button>
            </div>
          </div>
        </div>
      </div>
    );
  };

  return (
    <>
      <ModalPop
        title={"Change Status"}
        show={changeStatus}
        handleModalHide={() => { onClosePopup(); }}
      >
        <Fragment>
          <FormSection>{carnivalStatus()}</FormSection>
        </Fragment>
      </ModalPop>
      <ModalPop
        title={localization.conf}
        show={isModal}
        handleModalHide={handleModalHide2}
        keyboard
        backdrop
      >
        <div className="text-center">
          <div className="success">
            <img src={Images?.tick} alt="" />
          </div>
          <h5>{localization.carnivalStatusUpdate}</h5>
          <Button onClick={handleModalHide2} className="btn btn-primary mb-4">
            {localization.goToCarnivalListing}{' '}
            <img src={Images?.ArrowRight} alt="" />
          </Button>
        </div>
      </ModalPop>
    </>
  );
};
AddHelpdeskPopup.propTypes = {
  data: PropTypes.any,
  handleValue: PropTypes.func,
};


export default (AddHelpdeskPopup);
